import React, { Component } from 'react';
import Constants from '../../../../definitions/constants';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import toastr from 'toastr';

import TextBox from './textBox';
import FetchAutocompleteTextBox from './fetchAutocompleteTextBox';

class FetchAutocompleteList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      className,
      values,
      options,
      onChange,
      labelLocale,
      addSelectLocale,
      valueAccesor,
      labelAccesor,
      hideList,
      disabled,
      fetchListAction,
      loadingFetch,
      minSearchLength
    } = this.props;
    const dataPath = this.props["data-path"];
    return (
      <div className={"custom-input free-text-list select-list fetch-autocomplete-list select-list-no-search" + (className ? " " + className : "")}>
        {labelLocale && (
          <div className="free-text-list-label">
            {labelLocale}
          </div>
        )}
        {(!hideList && !disabled) && (
          <FetchAutocompleteTextBox
            className="free-text-list-list-add-item"
            labelLocale={addSelectLocale + ((values && values.length>0) ? " (" + values.length + ")" : "")}
            fetchAction={fetchListAction}
            loadingFetch={loadingFetch}
            fetchedData={options ? options : []}
            onClickOption={onChange}
            data-selectlist={"true"}
            data-path={dataPath}
            minSearchLength={minSearchLength}
            showClearSearchButton={true}
          />
        )}
        {!hideList && (
          <div className="free-text-list-list-wrapper">
            {values && values.map((item,i) => {
                if(!this.state.searchText=="" && 
                !item[this.props.labelAccesor].toUpperCase().indexOf(this.state.searchText.toUpperCase()) > -1) {
                  return null;
                }
                return (
                  <div key={i} className="free-text-list-list-item">
                    <div className="free-text-list-list-item-inner" title={item[this.props.labelAccesor]}>{item[this.props.labelAccesor]}</div>
                    {!disabled && (
                      <div className="free-text-list-list-item-action-buttons">
                        <i 
                          className="fas delete-action fa-trash"                          
                          data-index={i}
                          data-delete={"true"}
                          data-selectlist={"true"}
                          data-path={dataPath}
                          onClick={onChange}
                        />
                      </div>
                    )}
                  </div>
                );           
            })}
          </div>
        )}
      </div>
    );
  }
}

export default FetchAutocompleteList;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/fetchAutocompleteList.jsx